import { useTranslation } from 'react-i18next';
import { MIN_ENTROPY, MAX_ENTROPY, ENTROPY_STEP } from './constants';
import {
  StyledEntropyLabel,
  StyledEntropyLabelsContainer,
  StyledEntropySlider,
  StyledEntropySliderContainer,
  StyledEntropyTitle,
  StyledFileInfoBox,
  StyledFileName,
  StyledInstrumentLabel,
  StyledUserLoopSelector,
} from './styled';
import { UserLoopSelectorProps } from './types';

const UserLoopSelector = ({ value, onChange }: UserLoopSelectorProps) => {
  const { t } = useTranslation();

  const { entropy, instrument, loopFileName } = value;

  const handleChange = (newValue: number) => {
    onChange({ ...value, entropy: newValue });
  };

  return (
    <StyledUserLoopSelector>
      <StyledFileInfoBox>
        <StyledFileName>{loopFileName}</StyledFileName>
        <StyledInstrumentLabel
          label={t(
            `aiMusicGenerator:instruments:${instrument.replace(' ', '_')}`
          )}
          variant="outlined"
        />
      </StyledFileInfoBox>
      <StyledEntropySliderContainer>
        <StyledEntropyTitle>
          {t('aiMusicGenerator:userLoopSelector:entropy')}
        </StyledEntropyTitle>
        <StyledEntropySlider
          value={entropy}
          onChange={(_event, newValue) => handleChange(newValue as number)}
          step={ENTROPY_STEP}
          max={MAX_ENTROPY}
          min={MIN_ENTROPY}
          track={false}
          valueLabelFormat={(sliderValue) => (sliderValue * 100).toString()}
          valueLabelDisplay="auto"
        />
        <StyledEntropyLabelsContainer>
          <StyledEntropyLabel>
            {t('aiMusicGenerator:userLoopSelector:preserve')}
          </StyledEntropyLabel>
          <StyledEntropyLabel>
            {t('aiMusicGenerator:userLoopSelector:transform')}
          </StyledEntropyLabel>
        </StyledEntropyLabelsContainer>
      </StyledEntropySliderContainer>
    </StyledUserLoopSelector>
  );
};

export default UserLoopSelector;
